import { useState } from 'react';
import { Box, HStack, IconButton, Text, useToast } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faCheck } from '@fortawesome/free-solid-svg-icons';

export const CodeBlock = ({ children, label = 'code' }) => {
  const toast = useToast();
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(children);
    setCopied(true);
    toast({ title: 'Copied to clipboard', status: 'success', duration: 1500 });
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <Box position="relative" bg="gray.900" borderRadius="xl" overflow="hidden" my={4}>
      <HStack justify="space-between" px={4} py={2} bg="gray.800" borderBottom="1px solid" borderColor="gray.700">
        <Text fontSize="xs" color="gray.400" fontFamily="mono">{label}</Text>
        <IconButton
          size="xs"
          variant="ghost"
          color="gray.400"
          aria-label="Copy code"
          icon={<FontAwesomeIcon icon={copied ? faCheck : faCopy} />}
          onClick={handleCopy}
          _hover={{ color: 'white', bg: 'whiteAlpha.200' }}
        />
      </HStack>
      <Box as="pre" p={4} overflowX="auto" fontFamily="mono" fontSize="sm" color="gray.100" whiteSpace="pre">
        {children}
      </Box>
    </Box>
  );
};

export default CodeBlock;
